import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const listDeliveryTeams = ({ options = {} }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/delivery_teams' })
    handleCall(req, resolve, reject, true, options)
  })
